// extracted by mini-css-extract-plugin
export var headerCell = "_4k-1";
export var loadingSpinnerContainer = "_4k-4";
export var rowWrapper = "_4k-3";
export var standaloneTable = "_4k-5";
export var table = "_4k-0";
export var white = "_4k-2";